import { LOCATION_QUERY } from "@/apollo/queries";
import { FOOTER_QUERY } from "@/apollo/queries";
import Banner from "@/components/Banner";
import Loader from "@/components/Loader";
import SEOHead from "@/components/SEO";
import { useQuery } from "@apollo/client";
import { Box, Flex, Text, Container, Stack } from "@chakra-ui/react";
import Image from "next/image";
import React from "react";

const Locations = () => {
  const { loading, error, data } = useQuery(LOCATION_QUERY);

  const mapDetail = [
    {
      address:
        " 306 – Rajhans Complex 2, Near Nirmal Hospital, Ring Road,Surat – 395002",
      url: "/images/Flag_of_India.svg.webp",
      iframeurl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3720.268354734582!2d72.82272431538257!3d21.181495985915795!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04e7ad3f82f95%3A0x9f0936e29e4073ed!2sSparkle%20Infotech!5e0!3m2!1sen!2sin!4v1678702273660!5m2!1sen!2sin",
    },
    {
      address: "202 timberlane drive, Brampton, Ontario",
      url: "/images/Canada-flag.jpg",
      iframeurl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3340.939861311424!2d-96.82217652513467!3d33.13694447351534!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c3df850e5bded%3A0x7b426e391bb9532!2s7549%20Stonebrook%20Pkwy%2C%20Frisco%2C%20TX%2075034%2C%20USA!5e0!3m2!1sen!2sin!4v1681795618790!5m2!1sen!2sin",
    },
  ];
  const defaultMapStyle = {
    maxWidth: "80px",
    width: "full",
    margin: "0 auto 20px",
    cursor: "pointer",
  };

  const textStyle = {
    fontSize: "18px",
    color: "#0e2b5c",
    fontWeight: "nornmal",
    textAlign: "center",
  };

  const mapWrapStyle = {
    width: "full",
    flexDirection: "column",
    justifyContent: "space-between",
  };

  const iframeStyle = {
    width: "full",
    height: "420",
  };

  if (loading) {
    return <Loader />;
  }

  if (error) {
    console.error(error);
    return null;
  }

  const { MainSec, Contact_Us, SEO } = data.locationPage.data.attributes;

  return (
    <>
      <SEOHead title={SEO.pageTitle} description={SEO.pageDescription} />
      <Banner
        data={MainSec}
        locationBanner
        style={{ align: "center", textAlign: "" }}
        classNameparent="bannerOverlay"
      />
      <Box
        px={{ base: 5, md: 8, xl: 5 }}
        pt={{ base: 10, md: 16 }}
        pb={{ base: 0, md: 3 }}
      >
        <Container as={Stack} maxW={"7xl"} p={0}>
          <Flex
            gap={10}
            flexDirection={{ base: "column", md: "column", lg: "row" }}
          >
            {mapDetail.map((item) => {
              return (
                <>
                  <Flex {...mapWrapStyle}>
                    <Box>
                      <Box {...defaultMapStyle}>
                        <Image
                          className="mb-0"
                          height={53}
                          width={150}
                          src={item.url}
                          alt={"Flag-Logo"}
                          style={{ height: "53px" }}
                        />
                      </Box>
                      <Box mb={{ base: 8, md: 5 }} px={{ base: 4, md: 0 }}>
                        <Text {...textStyle}>{item.address}</Text>
                      </Box>
                    </Box>
                    <Box
                      {...iframeStyle}
                      boxShadow={
                        "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px"
                      }
                      p={{ base: 3, md: 5 }}
                    >
                      <iframe
                        src={item.iframeurl}
                        height={"100%"}
                        width={"100%"}
                        style={{ border: "0" }}
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                      ></iframe>
                    </Box>
                  </Flex>
                </>
              );
            })}
          </Flex>
        </Container>
      </Box>

      <Banner data={Contact_Us} classNamechild />
    </>
  );
};

export default Locations;
